export default {
  name: 'head-browser',
  initialize() {
    // do nothing!
    // this functionality has been moved into addon/components/head-layout.js
    // This is only here in order to not break existing addons relying on this, e.g. ember-page-title.
  },
};
